import React from "react";
import { Box, ThemeProvider as MuiThemeProvider } from "@mui/material";
import { themeTokensLegacyFonts } from "./themeTokens";

interface IUnauthenticatedThemeProviderProps {
  children: React.ReactNode;
}
/** No signed-in user here, so no flag can be evaluated; stays on the pre-Geist typography the login stylesheets already use. */
export const UnauthenticatedThemeProvider: React.FC<
  IUnauthenticatedThemeProviderProps
> = ({ children }) => {
  return (
    <MuiThemeProvider theme={themeTokensLegacyFonts}>
      <Box
        sx={{ background: themeTokensLegacyFonts.palette.surface.surface0 }}
        className="css-gcjmkb" // legacy MUI v5 hash kept for customer CSS compat, do not remove
      >
        {children}
      </Box>
    </MuiThemeProvider>
  );
};
